export default {
    /**
     * 当前时间转换成本周时间
     * @param value
     * @returns {string}
     */
    dateToWeek : function (value){
        if(value!="" && value.length>0){
            var today=new Date(value.substring(0,10));
            var weekday=today.getDay();
            var monday;
            var sunday;
            monday=new Date(1000*60*60*24*(6-weekday) + today.getTime());
            if (weekday==0) {
                sunday=today;
            }  else {
                sunday=new Date(1000*60*60*24*(0-weekday) + today.getTime());
            }
            var month = monday.getMonth()+1;
            if(month<10)
            {
                month = "0"+month;
            }
            var day1 = monday.getDate();
            if(day1<10)
            {
                day1 = "0"+day1;
            }
            var end = ""+monday.getFullYear()+"-"+month+"-"+day1;
            var month2 = sunday.getMonth()+1;
            if(month2<10)
            {
                month2 = "0"+month2;
            }
            var day2 = sunday.getDate();
            if(day2<10)
            {
                day2 = "0" + day2;
            }
            var start = ""+sunday.getFullYear()+"-"+month2+"-"+day2;
            return (start+"~"+end);
        }else{
            return '';
        }
    },

    /**
     * @描述：获取今天年月日
     * @创建时间：2015年12月23日
     */
    getTodayDate : function() {
        var nowDate = new Date();
        var year = nowDate.getFullYear();
        var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
        var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate
            .getDate();
        var dateStr = year + "-" + month + "-" + day;
        return dateStr;
    },

    /**
     * 计算本年的周数
     * @param endDate
     * @returns {number}
     */
    getYearWeek : function (endDate) {
        //本年的第一天
        var beginDate = new Date(endDate.getFullYear(), 0, 1);
        //星期从0-6,0代表星期天，6代表星期六
        var endWeek = endDate.getDay()+1;
        var beginWeek = beginDate.getDay()+1;
        //计算两个日期的天数差
        var millisDiff = endDate.getTime() - beginDate.getTime();
        var dayDiff = Math.floor(( millisDiff + (beginWeek - endWeek) * (24 * 60 * 60 * 1000)) / 86400000);
        return Math.ceil(dayDiff / 7) + 1;
    },
    /**
     * 日期截取年月日部分后返回
     */
    dateToyyyyMMdd:function (src){
        return src?src.substring(0,10):''
    },
    /**
     * 日期格式化
     * fmt：yyyy-MM-dd HH:mm
     */
    dateFormat: function(fmt, date) {
        let ret
        const opt = {
            'y+': date.getFullYear().toString(), // 年
            'M+': (date.getMonth() + 1).toString(), // 月
            'd+': date.getDate().toString(), // 日
            'H+': date.getHours().toString(), // 时
            'm+': date.getMinutes().toString(), // 分
            's+': date.getSeconds().toString(), // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        }
        for (let k in opt) {
            ret = new RegExp('(' + k + ')').exec(fmt)
            if (ret) {
                fmt = fmt.replace(
                    ret[1],
                    ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
                )
            }
        }
        return fmt
    }
}